<template>
    <div class="invalid-wrap" :style="{ paddingTop, marginBottom }">
        <div class="md-invalid unfind">
            <div class="img-box">
                <img
                    src="//static.chimeroi.com/site/images/template/404-text.png"
                    alt
                />
            </div>
            <div class="text-box">
                <p>{{ $t('md-invalid.thePageYouAreLooking') }}</p>
            </div>
        </div>
        <a href="/" class="back-home" rel="noopener noreferrer">{{
            $t('md-invalid.backToHome')
        }}</a>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    created() {
        const root = this.$root;
        if (
            root &&
            root.moduleData &&
            root.moduleData[0].name === 'md-header'
        ) {
            root.moduleData[0].data.overlap = false;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-invalid.unfind {
    .img-box {
        text-align: center;
        img {
            width: 300px;
            opacity: 0.8;
            // margin-top: 100px;
        }
    }
    .text-box {
        text-align: center;
        p {
            // margin: 60px 0 40px;
            color: #505050;
            font-family: var(--font-normal);
            font-size: 24px;
            margin-top: 60px;
        }
        a {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            width: 168px;
            @include color-theme('background-color');
            color: #fff;
            font-size: 16px;
            margin-top: 30px;
        }
    }
    @include media-800 {
        .text-box {
            p {
                margin: 60px 0 0;
            }
        }
    }
    @include media-600 {
        .img-box {
            img {
                margin-top: 50px;
            }
        }
        .text-box {
            p {
                margin-top: 30px;
                margin-bottom: 0;
                font-size: 16px;
            }
            a {
                font-size: 14px;
                height: 35px;
                line-height: 35px;
                width: 146px;
                margin-top: 15px;
            }
        }
    }
    @include media-375 {
        .img-box {
            img {
                max-width: 305px;
                height: 124px;
            }
        }
        .text-box {
            p {
                margin-top: 30px;
                margin-bottom: 0;
                padding: 0 10px;
                font-size: 14px;
                font-weight: bold;
                line-height: 1.5;
                letter-spacing: normal;
                color: #282828;
            }
        }
    }
}

.invalid-wrap .back-home {
    display: block;
    text-align: center;
    width: 148px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: #ffffff;
    background: #1daaf0;
    border-radius: 2px;
    margin: 30px auto 0;
}
</style>
